import { ApiBase, ApiResponse } from '../api-base';
import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { SerieSettingEntity } from './serie-setting-entity';

@inject(IHttpClient)
export class SerieApi extends ApiBase {

    constructor(http: IHttpClient) {
        super(http);
    }

    public async add(scheduleId: string, entity: SerieSettingEntity): Promise<SerieSettingEntity> {
        const dto = entity.toDto();
        const response = await this.post(this._baseUrl(scheduleId), dto);
        return SerieSettingEntity.fromDto(response.content);
    }

    public async update(scheduleId: string, id: string, entity: SerieSettingEntity): Promise<SerieSettingEntity> {
        const dto = entity.toDto();
        const response = await this.patch(this._baseUrl(scheduleId) + '/' + id, dto);
        return SerieSettingEntity.fromDto(response.content);
    }

    public async getById(scheduleId: string, id: string): Promise<SerieSettingEntity> {
        const response = await this.get(this._baseUrl(scheduleId) + '/' + id);
        return SerieSettingEntity.fromDto(response.content);
    }

    public async getByScheduleId(scheduleId: string): Promise<SerieSettingEntity> {
        const response = await this.get(this._baseUrl(scheduleId));
        return SerieSettingEntity.fromDto(response.content);
    }

    public async deleteById(scheduleId: string, id: string): Promise<ApiResponse> {
        const response = await this.delete(this._baseUrl(scheduleId) + '/' + id);
        return response;
    }

    private _baseUrl(scheduleId: string): string {
        return `api/schedules/${scheduleId}/series`;
    }
}
